import { render, staticRenderFns } from "./VisitorUsers.vue?vue&type=template&id=0963be5a&"
import script from "./VisitorUsers.vue?vue&type=script&lang=js&"
export * from "./VisitorUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports